import React, { useState } from 'react';
import { TableCell, TableRow, } from "@mui/material";
import clsx from "clsx";
import { Link, NavLink } from "react-router-dom";
import { Space, Image, Dropdown, Menu } from "antd";
import ElipsisIcon from "../../../../../assets/images/icon_actions/Elipsis.svg";
import EditIcon from "../../../../../assets/images/icon_actions/Edit.svg";
import DeleteIcon from "../../../../../assets/images/icon_actions/Delete Icon.svg";
import ViewIcon from "../../../../../assets/images/icon_actions/View.svg";
import CustomInfiniteScroll from "../../../../Shared/components/CustomInfiniteScroll";
import customStyles from "../../../../../assets/styles/customStyles";
import moment from 'moment';
import { currencyFormat, capitalizeFirstLetter, getColumnWidth, checkComponentPermission, checkCRUDPermission, idNamingConversion } from "../../../../../helpers/utilities";
import { AESEncrypt } from "../../../../../helpers/Crypto";
import DeleteModal from "../../../../Shared/components/DeleteModal";
import { CustomModal } from "../../../../Shared/components/DeleteModal";
import { SendReceiptForm } from './Blocks/SendReceiptForm';
import { emptyValidation, customNumberValidation } from "../../../../../helpers/validation";
import SalesModal from "../../../../Shared/components/SalesModal";


export const CustomTable = (props) => {
    const { heads, onRequestSort, loadMoreTask, loadMore,
        loadTasks, loadMoreContent, sortOrder, sortBy, details, roleManagement } = props;
    const classes = customStyles();
    const [bill, setBill] = useState({});
    const [form, setForm] = useState({});
    const [error, setError] = useState({});
    const [billDeleteId, setBillDeleteId] = useState('');
    const [deleteModal, setDeleteModal] = useState(false);
    const [receipt, setReceipt] = useState(false);
    const [visible, setVisible] = useState(false);


    const onDelete = (data) => {
        setDeleteModal(true);
        setBill(data);
        setBillDeleteId(data?.id);
    }

    const handleSendReceipt = (data) => {
        setError({});
        setForm({
            customerName: data?.customerName || data?.customer?.name,
            customerEmail: data?.customerEmail || data?.customer?.email || '',
            customerMobile: data?.customerMobile || data?.customer?.mobile
        });
        setReceipt(true);
    }

    const handlePrint = (data) => {
        setForm({
            ...data,
            amountReceived: data?.customerPayments && data?.customerPayments.length > 0 ? data?.customerPayments.reduce((a, v) => a = parseFloat(a) + parseFloat(v.paymentAmount), 0) : 0,

        });
        setVisible(true);
    }

    const changeHandler = (e) => {
        setForm({
            ...form, [e.target.name]: e.target.value
        })
    }

    const handleReceiptSubmit = () => {
        let emptyCustomerName = emptyValidation('Customer Name', form.customerName);
        let emptyCustomerEmail = emptyValidation('Customer Email', form.customerEmail);
        let emptyCustomerPhone = customNumberValidation('Customer Phone', form.customerMobile);
        setError({});
        if (emptyCustomerName.isValid && emptyCustomerEmail.isValid && emptyCustomerPhone.isValid) {
        } else {
            setError({
                customerName: emptyCustomerName?.errors || '',
                customerEmail: emptyCustomerEmail?.errors || '',
                customerMobile: emptyCustomerPhone?.errors || ''
            })
        }
    }

    return (
        <>
            <CustomInfiniteScroll
                loadMore={loadMore}
                loadMoreContent={loadMoreContent}
                heads={heads}
                onRequestSort={(sortBy, sortOrder) => onRequestSort(sortBy, sortOrder)}
                sortOrder={sortOrder}
                width={true}
                sortBy={sortBy}
                loadMoreTask={() => loadMoreTask()}
                details={details}
                className={classes.margin15t}
                component={
                    <>
                        {
                            !loadMore || details === '' ? (
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} key={"customTable"}>
                                    <TableCell className={classes.textAlignCenter} colSpan={heads.length}><div className={classes.loadMoreCircle}></div></TableCell>
                                </TableRow>
                            ) : (
                                <React.Fragment>
                                    {
                                        details && Array.isArray(details) && details.length > 0 ? details.map((data, i) => (
                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} key={i}>
                                                <TableCell style={{ width: getColumnWidth(heads, 0) }} className={classes.positionRelative}>
                                                    <Link id={idNamingConversion('View_' + data.id, 'storeSales', 'Link')} to={`/sales/sales-management/store-sales/${AESEncrypt(data.id)}/view`} className={clsx(classes.color, classes.wordBreak, classes.disBlock, classes.bold)}>{data.cashReceiptNumber}</Link>
                                                </TableCell>
                                                <TableCell style={{ width: getColumnWidth(heads, 1) }}><span style={{ width: getColumnWidth(heads, 1) }}>{data?.customerName || '---'}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(heads, 2) }}><span style={{ width: getColumnWidth(heads, 2) }}>{data?.customerMobile || '---'}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(heads, 3) }}><span style={{ width: getColumnWidth(heads, 3) }}>{data?.customerEmail || '---'}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(heads, 4) }}><span style={{ width: getColumnWidth(heads, 4) }}>{data?.transactionDate ? moment(data?.transactionDate).format('DD MMM YYYY') : '---'}</span></TableCell>
                                                <TableCell className={classes.textAlignRight} style={{ width: getColumnWidth(heads, 5) }}><span style={{ width: getColumnWidth(heads, 5) }}>{`₹ ${currencyFormat((data?.invoiceAmount || 0))}`}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(heads, 6) }}><span style={{ width: getColumnWidth(heads, 6) }}>{data?.storeSalesUser?.name || '---'}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(heads, 6) }}><span style={{ width: getColumnWidth(heads, 7) }}>{data?.posName || '---'}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(heads, 7) }}><div className={clsx(classes.statusButton, { [classes.confirmedButton]: data.billStatus === 'CONFIRMED' },
                                                    { [classes.reversedButton]: data.billStatus === 'REVERSED' },
                                                    { [classes.cancelledButton]: data.billStatus === 'CANCELLED' })}>{capitalizeFirstLetter(data.billStatus)}</div>
                                                </TableCell>
                                                <TableCell style={{ width: getColumnWidth(heads, 8) }}><span style={{ width: getColumnWidth(heads, 5) }}>{data.salesType === 'Sale' ? 'New Sales' : data.salesType}</span>
                                                </TableCell>
                                                <TableCell>
                                                    <Space direction="horizontal" align="center" size={[0, 0]} className={clsx(classes.iconPadding, classes.actionWidth)}>
                                                        {
                                                            roleManagement !== '' && checkCRUDPermission('Store Sales', 'view', 'Sales') &&
                                                            <Link id={idNamingConversion('View_' + data.id, 'storeSales', 'Icon')} to={`/sales/sales-management/store-sales/${AESEncrypt(data.id)}/view`}>
                                                                <Image src={ViewIcon} preview={false} />
                                                            </Link>
                                                        }
                                                        {
                                                            roleManagement !== '' && checkCRUDPermission('Store Sales', 'view', 'Sales') &&
                                                            <Link id={idNamingConversion('Edit_' + data.id, 'storeSales', 'Icon')} to={`/sales/sales-management/store-sales/${AESEncrypt(data.id)}/edit`}
                                                                className={clsx({ [classes.disabled]: data.billStatus !== 'CREATED' })}>
                                                                <Image src={EditIcon} preview={false} />
                                                            </Link>
                                                        }
                                                        {
                                                            roleManagement !== '' && checkCRUDPermission('Store Sales', 'deletable', 'Sales') &&
                                                            <NavLink id={idNamingConversion('Delete_' + data.id, 'storeSales', 'Icon')} to={"#"} className={clsx({ [classes.disabled]: data.billStatus !== 'CREATED' })} onClick={() => onDelete(data)}>
                                                                <Image src={DeleteIcon} preview={false} />
                                                            </NavLink>
                                                        }
                                                        <Dropdown
                                                            trigger={['click']}
                                                            placement={'bottomRight'}
                                                            overlay={
                                                                <Menu className={clsx(classes.groupMenu)}>
                                                                    {
                                                                        data.billStatus === 'CONFIRMED' && <>
                                                                            {
                                                                                roleManagement !== '' && checkComponentPermission('Store Sales', 'Ellipsis Action', 'Send Receipt') &&
                                                                                <Menu.Item key={"Send Receipt"}><NavLink to={'#'} id={idNamingConversion('Send Receipt_' + data.id, 'storeSales', 'Link')} onClick={() => handleSendReceipt(data, false)}>Send Receipt</NavLink></Menu.Item>
                                                                            }
                                                                            {
                                                                                roleManagement !== '' && checkComponentPermission('Store Sales', 'Ellipsis Action', 'Print') &&
                                                                                <Menu.Item key={"Print"}><NavLink to={'#'} id={idNamingConversion('Print_' + data.id, 'storeSales', 'Link')} onClick={() => handlePrint(data, true)}>Print</NavLink></Menu.Item>
                                                                            }
                                                                            {
                                                                                roleManagement !== '' && checkComponentPermission('Store Sales', 'Ellipsis Action', 'Cancel') &&
                                                                                <Menu.Item key={"Cancel"}><NavLink to={'#'} id={idNamingConversion('Cancel_' + data.id, 'storeSales', 'Link')} onClick={() => handlePrint(data, true)}>Cancel</NavLink></Menu.Item>
                                                                            }
                                                                        </>
                                                                    }
                                                                </Menu>
                                                            }>
                                                            <Image
                                                                id={idNamingConversion('Elipsis_' + data.id, 'storeSales', 'Icon')}
                                                                src={ElipsisIcon}
                                                                preview={false}
                                                            />
                                                        </Dropdown>
                                                    </Space>
                                                </TableCell>
                                            </TableRow>
                                        )) : (
                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell className={classes.textAlignCenter} colSpan={heads.length}> <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>{'Start Creating Store Sales'}</p></TableCell>
                                            </TableRow>
                                        )
                                    }
                                </React.Fragment>
                            )
                        }
                    </>
                }
            />
            <CustomModal
                onClose={(v) => { setReceipt(v); setError({}); }}
                yesButton={'OK'}
                noButton={'Cancel'}
                title={'Send Receipt'}
                visible={receipt}
                onOpen={() => handleReceiptSubmit()}
                text={
                    <SendReceiptForm
                        changeHandler={(e) => changeHandler(e)}
                        error={error}
                        form={form}
                    />
                }
            />
            {
                visible && <SalesModal
                    visible={visible}
                    classes={classes}
                    previewType={'storeSales'}
                    handleClose={() => setVisible(false)}
                    details={form}
                />
            }
            <DeleteModal onClose={(v) => setDeleteModal(v)} id={billDeleteId} loadTasks={() => loadTasks()}
                name={bill?.cashReceiptNumber} url={'store-sales'} title={bill?.salesType === 'Sale Return' ? 'Sales Return' : 'Store Sales'}
                visible={deleteModal} />
        </>
    )
}
